import { useEffect } from "react";

import PropTypes from "prop-types";
import { useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Stack,
} from "@mui/material";

import { CustomDialogTitle, CustomInputField } from "../../../ui";
import {
  DEFAULT_VALUES,
  VALIDATION_SCHEMA,
} from "./supplier-contact-form-constants";

export const SupplierContactForm = ({ defaultValues, onSubmit, onClose }) => {
  const {
    control,
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: DEFAULT_VALUES,
    resolver: yupResolver(VALIDATION_SCHEMA),
  });

  useEffect(() => {
    if (defaultValues) reset({ ...DEFAULT_VALUES, ...defaultValues });
  }, [defaultValues, reset]);

  const handleClose = () => {
    reset();
    onClose();
  };

  const onFormSubmit = (data) => {
    onSubmit(data);
    onClose();
  };

  return (
    <Dialog
      open
      fullWidth
      maxWidth="xs"
      component="form"
      onClose={handleClose}
      onSubmit={(e) => {
        e.preventDefault();
        e.stopPropagation();
        handleSubmit(onFormSubmit)(e);
      }}
    >
      <CustomDialogTitle variant="h5" title="Kontak" onClose={handleClose} />
      <DialogContent>
        <Stack spacing={2}>
          <CustomInputField
            required
            control={control}
            name="name"
            label="Nama"
            register={register}
            helperText={errors.name?.message}
            error={Boolean(errors.name)}
            InputProps={{
              placeholder: "Cth: John Doe",
            }}
          />
          <CustomInputField
            required
            control={control}
            name="position"
            label="Jabatan"
            register={register}
            helperText={errors.position?.message}
            error={Boolean(errors.position)}
          />
          <CustomInputField
            control={control}
            name="email"
            label="Email"
            register={register}
            helperText={errors.email?.message}
            error={Boolean(errors.email)}
          />
          <CustomInputField
            required
            control={control}
            name="phoneNumber"
            label="No. HP"
            register={register}
            helperText={errors.phoneNumber?.message}
            error={Boolean(errors.phoneNumber)}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" type="submit">
          Simpan
        </Button>
      </DialogActions>
    </Dialog>
  );
};

SupplierContactForm.propTypes = {
  defaultValues: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
